import React from "react";

const personalInfo = [
  { meta: "first name", metaInfo: "Gunjan Kela" },
  {meta:'Designation', metaInfo:'Founder'},
  { meta: "Address", metaInfo: "Chh Sambhaji Nagar" },
  { meta: "Email", metaInfo: "kelagunjan97@gmail.com" },
];

const Perso = () => {
  return (
    <ul className="about-list list-unstyled open-sans-font">
      {personalInfo.map((val, i) => (
        <li key={i}>
          <span className="title">{val.meta}: </span>
          <span className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block">
            {val.metaInfo}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default Perso;
